import { useState, useCallback } from "react";
import { useApp } from "@/context/AuthContext";

const KEY = "zl_autoplay";

// Autoplay ("Read to me" / independent learning) state.
// Seeded from the student's teacher/parent-set default, overridable per device.
export function useAutoplay() {
  const { user } = useApp();
  const stored = typeof window !== "undefined" ? localStorage.getItem(KEY) : null;
  const initial = stored === null ? !!user?.autoplay : stored === "1";
  const [on, setOn] = useState(initial);
  const toggle = useCallback(() => {
    setOn((v) => {
      const n = !v;
      try { localStorage.setItem(KEY, n ? "1" : "0"); } catch (_) {}
      return n;
    });
  }, []);
  return [on, toggle];
}
